import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthScreenComponent} from './rx-auth/auth-screen/auth-screen.component';
import {LandingPageComponent} from './landing/landing-page/landing-page.component';
import {RetailerProfileComponent} from './profiles/retailer-profile/retailer-profile.component';
import {ExplorerComponent} from './explore/explorer/explorer.component';
import {ProfileWrapperComponent} from './profiles/profile-wrapper/profile-wrapper.component';
import {LogoutComponent} from './rx-auth/logout/logout.component';
import {BackComponent} from "./shared/toolbox/back/back.component";

import {TestServeComponent} from './test/test-serve/test-serve.component';
import {PublicChartComponent} from './public-chart/public-chart/public-chart.component';
import {SavedChartsComponent} from './lists/saved-charts/saved-charts.component';
import {ErrorScreenComponent} from './rx-auth/error-screen/error-screen.component';
import {DashboardComponent} from './profiles/dashboard/dashboard.component';
import {DashboardResolver} from './resolvers/dashboardResolver';
import {ProfileResolver} from './resolvers/profileResolver';

// LB EXTRAS
import {LbDashboardComponent} from "./lbarometer/lb-dashboard/lb-dashboard.component";
import {authGuard} from "./lbarometer/guards/auth.guard";
import { LbSurveyComponent } from './lbarometer/lb-survey/lb-survey.component';
import { SingleBarChartComponent } from './shared/toolbox/charts/single-bar-chart/single-bar-chart.component';
import { ComparedBarChartComponent } from './shared/toolbox/charts/compared-bar-chart/compared-bar-chart.component';
import { ChartWrapperComponent } from './shared/toolbox/charts/chart-wrapper/chart-wrapper.component';
import {ProfileTopMatterComponent} from "./profiles/profile-top-matter/profile-top-matter.component";



const routes: Routes = [
  // LB ROUTES

  {
    path: 'leadership-barometer',
    canActivate: [authGuard], // Guard applied to the parent and inherited by children
    children: [
      { path: '', component: LbDashboardComponent}, // Redirect empty path to 'dashboard'
      { path: 'take-the-survey', component: LbSurveyComponent},
      { path: ':survey_code', component: LbDashboardComponent}, //Keep always in last position
      // Add other child routes here
    ],
  },
  {path: 'landing', component: LandingPageComponent},
  {path: 'ret-profile', component: RetailerProfileComponent},
  {path: 'saved-charts', component: SavedChartsComponent},
  {path: 'shared', component: PublicChartComponent},
  {
    path: 'profile',
    component: ProfileWrapperComponent,
    resolve: {
      profileData: ProfileResolver
    }
  },
  {path: 'explore', component: ExplorerComponent},
  {path: 'test', component: TestServeComponent},
  {path: 'logout', component: LogoutComponent},
  {path: 'rxlogin', component: AuthScreenComponent},
  {path: 'capacity-reached', component: ErrorScreenComponent},
    {path: 'chart-test', component:SingleBarChartComponent},
    {path: 'chart-test2', component:ComparedBarChartComponent},
  {path: 'back', component: BackComponent},

  /*{
    path: 'dashboard',
    component: DashboardComponent,
    resolve: {
      profileData: DashboardResolver
    },
    data: {
      sidebarTab: '/dashboard',
      breadCrumb: [
        { name: 'Dashboard', link: '/dashboard' }
      ]
    }
  },*/
  {path: '**', redirectTo: '/back', pathMatch: 'full'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
